var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"image",attrs:{"align":"left","src":_vm.url},on:{"click":function($event){return _vm.$emit('click', $event)},"error":_vm.onLoadImgError}})}
var staticRenderFns = []

export { render, staticRenderFns }